import listActions from 'src/modules/team/list/teamListActions';
import TeamService from 'src/modules/team/teamService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'TEAM_DESTROY';

const teamDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: teamDestroyActions.DESTROY_STARTED,
      });

      await TeamService.destroyAll([id]);

      dispatch({
        type: teamDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.team.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/team');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: teamDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: teamDestroyActions.DESTROY_ALL_STARTED,
      });

      await TeamService.destroyAll(ids);

      dispatch({
        type: teamDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.team.destroyAll.success'),
      );

      getHistory().push('/team');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: teamDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default teamDestroyActions;
